import { http } from '../../../../api/http';
import type { ArticuloSerial } from '../types/serial.types';

export const serialService = {
  async getAll(idArticulo?: number, idDeposito?: number, estado?: string): Promise<ArticuloSerial[]> {
    const params = new URLSearchParams();
    if (idArticulo) params.append('idArticulo', idArticulo.toString());
    if (idDeposito) params.append('idDeposito', idDeposito.toString());
    if (estado) params.append('estado', estado);
    const response = await http.get(`/inventario/serial?${params.toString()}`);
    return response.data;
  },

  async getById(id: number): Promise<ArticuloSerial> {
    const response = await http.get(`/inventario/serial/${id}`);
    return response.data;
  },

  async save(serial: ArticuloSerial): Promise<ArticuloSerial> {
    const response = await http.post('/inventario/serial', serial);
    return response.data;
  },

  async saveBatch(serials: ArticuloSerial[]): Promise<ArticuloSerial[]> {
    const response = await http.post('/inventario/serial/batch', serials);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/inventario/serial/${id}`);
  },
};
